import React, { useState } from 'react';
import { RouteComponentProps } from 'react-router';

import './SpeakerDetail.scss';
import './SpeakerDetail.css';

import { ActionSheetButton } from '@ionic/core';
import { IonActionSheet, IonChip, IonIcon, IonHeader, IonLabel, IonToolbar, IonButtons, IonContent, IonButton, IonBackButton, IonPage } from '@ionic/react'
import { callOutline, callSharp, logoTwitter, logoGithub, logoInstagram, shareOutline, shareSharp } from 'ionicons/icons';
import SpeakerHeader from '../components/SpeakerHeader';
import { resolveImageUrl } from '../utils/imageUtils';

import { connect } from '../data/connect';
import * as selectors from '../data/selectors';

import { Speaker } from '../models/Speaker';


interface OwnProps extends RouteComponentProps<{ id: string }> {
  speaker?: Speaker;
};

interface StateProps {};

interface DispatchProps {};

interface SpeakerDetailProps extends OwnProps, StateProps, DispatchProps {};

const SpeakerDetail: React.FC<SpeakerDetailProps> = ({ speaker }) => {
  const [showActionSheet, setShowActionSheet] = useState(false);
  const [actionSheetButtons, setActionSheetButtons] = useState<ActionSheetButton[]>([]);
  const [actionSheetHeader, setActionSheetHeader] = useState('');

  function openSpeakerShare(speaker: Speaker) {
    setActionSheetButtons([
      {
        text: 'Copy Link',
        handler: () => {
          console.log('Copy Link clicked');
        }
      },
      {
        text: 'Share via ...',
        handler: () => {
          console.log('Share via clicked');
        }
      },
      {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }
    ]);
    setActionSheetHeader(`Share ${speaker.name}`);
    setShowActionSheet(true);
  }

  function openContact(speaker: Speaker) {
    setActionSheetButtons([
      {
        text: `Email ( ${speaker.email} )`,
        handler: () => {
          window.open('mailto:' + speaker.email);
        }
      },
      {
        text: `Call ( ${speaker.phone} )`,
        handler: () => {
          window.open('tel:' + speaker.phone);
        }
      }
    ]);
    setActionSheetHeader(`Share ${speaker.name}`);
    setShowActionSheet(true);
  }

  function openExternalUrl(url: string) {
    window.open(url, '_blank');
  }

  if (!speaker) {
    return <div>Speaker not found</div>
  }

  return (
    <IonPage id="speaker-detail">
      <IonContent>
        <IonButtons className="back-button-container">
          <IonBackButton defaultHref="/tabs/speakers" text="Volver" className="custom-back-button" />
        </IonButtons>

        <SpeakerHeader
          name={speaker.name}
          title={speaker.title || 'Speaker'}
          avatar={resolveImageUrl(speaker.profilePic) || ''}
          logo={speaker.logo}
          onCall={speaker.phone ? () => openContact(speaker) : undefined}
          onTwitter={speaker.twitter ? () => openExternalUrl(`https://twitter.com/${speaker.twitter}`) : undefined}
          onInstagram={speaker.instagram ? () => openExternalUrl(`https://instagram.com/${speaker.instagram}`) : undefined}
          onShare={() => openSpeakerShare(speaker)}
        />

        <div className="ion-padding speaker-detail">
          <p>{speaker.about}</p>

          <hr/>

          {/*<IonChip color="twitter" onClick={() => openExternalUrl(`https://twitter.com/${speaker.twitter}`)}>
            <IonIcon icon={logoTwitter}></IonIcon>
            <IonLabel>Twitter</IonLabel>
          </IonChip>

          <IonChip color="dark" onClick={() => openExternalUrl('https://github.com/ionic-team/ionic')}>
            <IonIcon icon={logoGithub}></IonIcon>
            <IonLabel>GitHub</IonLabel>
          </IonChip>

          <IonChip color="instagram" onClick={() => openExternalUrl('https://instagram.com/ionicframework')}>
            <IonIcon icon={logoInstagram}></IonIcon>
            <IonLabel>Instagram</IonLabel>
          </IonChip>*/}
        </div>
      </IonContent>
      <IonActionSheet
        isOpen={showActionSheet}
        header={actionSheetHeader}
        onDidDismiss={() => setShowActionSheet(false)}
        buttons={actionSheetButtons}
      />
    </IonPage>
  );
};


export default connect<OwnProps, StateProps, DispatchProps>({
  mapStateToProps: (state, ownProps) => {
    const speakerIdParam = ownProps.match.params.id;
    console.log('SpeakerDetail: Buscando speaker con ID:', speakerIdParam);
    console.log('SpeakerDetail: Speakers disponibles:', state.data.speakers.map((s: Speaker) => ({ id: s.id, name: s.name })));

    return {
      speaker: state.data.speakers.find((s: Speaker) => {
        // Comparar tanto como string como número para compatibilidad
        return s.id.toString() === speakerIdParam || s.id === parseInt(speakerIdParam, 10);
      })
    };
  },
  component: SpeakerDetail
});
